/**
 * Which TRON network this deployment talks to, and where the browser builds and
 * broadcasts a transfer.
 *
 * A wallet can be pointed at any chain, so the connect flow has to be able to say
 * "this is the wrong network" in words the visitor can act on — which needs the chain
 * id we expect, not just a node URL.
 */
import { webCoreConfig } from "../config.js";
const NETWORKS = {
    mainnet: {
        id: "mainnet",
        label: "TRON mainnet",
        chainId: "0x2b6653dc",
        fullHost: "https://api.trongrid.io",
        walletConnectNetwork: "Mainnet",
    },
    nile: {
        id: "nile",
        label: "Nile testnet",
        chainId: "0xcd8690dc",
        fullHost: "https://nile.trongrid.io",
        walletConnectNetwork: "Nile",
    },
};
/** The network this deployment targets, with the configured full node when there is one. */
export function tronNetwork() {
    const config = webCoreConfig();
    const base = NETWORKS[config.tronNetwork];
    const host = config.tronFullHost;
    return host ? { ...base, fullHost: host.replace(/\/$/, "") } : base;
}
/**
 * The WalletConnect project id, or `null` when this deployment has none.
 *
 * WalletConnect cannot work without one, so the rows that depend on it are hidden rather
 * than offered and then failed.
 */
export function walletConnectProjectId() {
    const value = webCoreConfig().walletConnectProjectId;
    const trimmed = typeof value === "string" ? value.trim() : "";
    return trimmed === "" ? null : trimmed;
}
//# sourceMappingURL=network.js.map